export default __webpack_public_path__ + "static/media/devto.047267a3.svg";